var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:("skeleton d-flex col-md-" + _vm.col + " mb-2"),style:(_vm.cssVars)})])}
var staticRenderFns = []

export { render, staticRenderFns }